import PaginationParams from './PaginationParams'
import DocumentTypes from './DocumentTypes'
import Student from './Student'
import Syllabus from './Syllabus'
import Activity from './Activity'
import { EquivalencyRule } from './EquivalencyRule'
import AppFile from './AppFile'
import { Proposal } from './Proposal'

export enum EquivalencyRequestStates {
  rejected = 'REJECTED',
  aproved = 'APPROVED',
  pending = 'PENDING',
  conditional= 'CONDITIONAL',
  regular = 'REGULAR',
  review = 'IN_REVIEW',
  draft = 'DRAFT'
}
export enum EquivalencyRequestActivityStates {
  rejected = 'REJECTED',
  aproved = 'APPROVED',
  pending = 'PENDING'
}


export type AcademicTranscript = {
  book: string,
  page: string,
  other: string,
}

export type RequestActivity = {
  id: string
  program_file: null | AppFile
  academic_transcript: AcademicTranscript
  approval_date: string
  grade: string
  state: EquivalencyRequestActivityStates
  source: string | null
  activity: Activity

}

export enum EquivalencyStates {
  rejected = 'GRANTED',
  aproved = 'REJECTED',
}

interface Equivalency {
  id: string
  state: EquivalencyStates
  activity: Activity
  observation: string | null
  rule: EquivalencyRule
  last_update_user: string
  last_update_date: string

}
interface Review {
  id: string,
  description: string,
}
export default interface EquivalencyRequest {
  id: string
  case_number: string
  equivalencies: Equivalency[] | null
  state: EquivalencyRequestStates
  observation: string | null
  editFiles: boolean
  deletedFiles: boolean
  student: Student
  syllabus: Syllabus
  target_syllabus: Syllabus
  files: AppFile[]
  activities: RequestActivity[]
  sourceActivities?: { id: string | null; name: string | null }[];
  created_date: string
  reCaptchaToken: string | undefined
  deal_id: string
  reviewed: boolean | null
  proposals: Proposal[] | null,
  review?: Review | null
  matchingActivities?: Activity[];
  rejectionDate?: string | null
}

export type EquivalencyRequestSearchParams = PaginationParams & {
  documentType: DocumentTypes
  documentNumber: string
  caseNumber: string,
  reCaptchaToken?: string
  id?: string
}

export type PreviousEquivalencyRequestParams = PaginationParams & {
  documentType?: DocumentTypes,
  documentNumber?: string,
  state?: EquivalencyRequestStates | string,
  sourceSyllabusName?: string,
  sourceSyllabusId?: string,
  sourceActivities?:  { id: string | null; name: string | null }[],
  targetSyllabusId?: string,
  generateToken?: () => Promise<string | undefined>
}

export type PaginatePrevEquivalencyResult = {
  count: number,
  items: EquivalencyRequest[]
}

export interface EquivalencyRequestSimulationSearchParams {
  student:{
    id: string
  }
  syllabus: {
    id: string | null
    name: string
    institution: {
      id: string | null
      name: string
    }
  },
  target_syllabus: {
    id: string | undefined
  },
  activities: {
    id: string;
    activity: {
      id: string | null;
      code: string;
      name: string;
      externalid: string;
    };
  }[]
}

export interface EquivalencyRequestParams {
  request: EquivalencyRequest,
  generateToken?: () => Promise<string | undefined>
}



export interface RequestById {
  id: string;
  case_number: string;
  state: string;
  observation: string;
  student: Student;
  syllabus: Syllabus;
  target_syllabus: Syllabus;
  files: FileItem[];
  editFiles: boolean;
  deletedFiles: boolean;
  review: any;
  reviewed: boolean;
  created_date: string;
  matchingActivities: any;
  activities: Activity[];
   equivalencies: Equivalency[];
  proposals: Proposal[];
  reviewRequest: any; // o null
  tags: Tag[];
}
  
export interface FileItem {
  id: string;
  sha: string;
  file_name: string;
  file_type: string;
  url: string;
}

export interface Tag {
  id: string;
  tag: string;
}
